var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memoize } from '@core/utils/hoc/memo.utils';
import { useCallback, useEffect, useState } from 'react';
import { Select } from '../select';
import { PaginationButton } from './pagination-button.component';
export var pageSizeSelectOptions = [
    { label: '10 строк', value: 10 },
    { label: '25 строк', value: 25 },
    { label: '50 строк', value: 50 },
];
export var Pagination = memoize(function (_a) {
    var onPageChange = _a.onPageChange, state = _a.state, onPageSizeChange = _a.onPageSizeChange;
    var _b = useState([]), viewedPages = _b[0], setViewedPages = _b[1];
    useEffect(function () {
        var partNum = Math.floor(state.pageNumber / 10);
        setViewedPages(Array.from({ length: 10 }, function (_, index) { return ({
            id: crypto.randomUUID(),
            page: partNum * 10 + (index + 1),
        }); }).filter(function (o) { return o.page <= state.totalPages; }));
    }, [state.pageNumber, state.totalPages]);
    var prevPage = useCallback(function () {
        onPageChange(state.pageNumber - 1);
    }, [state.pageNumber]);
    var nextPage = useCallback(function () {
        onPageChange(state.pageNumber + 1);
    }, [state.pageNumber]);
    return (_jsxs("div", __assign({ className: "flex flex-row items-center justify-end gap-[24px] pr-[39px]" }, { children: [_jsx(Select, { value: state.pageSize, options: pageSizeSelectOptions, onChange: function (value) { return value && onPageSizeChange(Number(value)); } }), _jsx("div", __assign({ className: "text-[14px] leading-[20px] tracking-[0.1px]" }, { children: viewedPages.length &&
                    "".concat(viewedPages[0].page, "-").concat(viewedPages[viewedPages.length - 1].page, " \u0438\u0437 ").concat(state.totalPages) })), _jsxs("div", __assign({ className: "flex flex-row items-center gap-2" }, { children: [_jsx(PaginationButton, { type: 'left', clickHandle: prevPage, disabled: !state.hasPreviousPage }), viewedPages.map(function (item) { return (_jsx(PaginationButton, { selected: item.page === state.pageNumber, type: 'page', pageNumber: item.page, clickHandle: function () {
                            onPageChange(item.page);
                        } }, item.id)); }), _jsx(PaginationButton, { type: 'right', clickHandle: nextPage, disabled: !state.hasNextPage })] }))] })));
}, 'Pagination');
